import comboModalPositionTemplate from '../templates/comboModalPosition.html';

function comboModalPositionDirective() {
    return {
        restrict: 'E',
        controller: function () {},
        controllerAs: 'comboModalPosition',
        bindToController: true,
        scope: {
            comboItemCtrl: '<?',
        },
        templateUrl: comboModalPositionTemplate,
    };
}

export { comboModalPositionDirective };
